/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import classNames from "classnames";
import "./chip.scss";
import { FC, memo } from "react";
import { Button } from "@components/button";
import { Cross } from "@components/icons";

interface ChipProps {
  variant?: "primary" | "secondary" | "active" | "inactive" | "draft";
  value?: string;
  className?: string;
  onRemove?: () => void;
  onClick?: () => void;
  textLimit?: number;
  disabled?: boolean;
}
const ChipComponent: FC<ChipProps> = ({
  variant = "primary",
  value,
  className,
  onRemove,
  onClick,
  textLimit = 100 | 110 | 120 | 130 | 140 | 150,
  disabled = false,
}) => {
  return (
    <div
      className={classNames("chip-container", className, {
        "primary-chip": variant === "primary",
        "secondary-chip": variant === "secondary",
        "active-chip": variant === "active",
        "inactive-chip": variant === "inactive",
        "draft-chip": variant === "draft",
      })}
      role="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
    >
      <span className={`chip-label${textLimit ? ` text-limit-${textLimit}` : ""}`}>
        {value ?? ""}
      </span>
      {onRemove && (
        <Button
          className="p-0"
          variant="transparent"
          onClick={() => {
            onRemove();
          }}
          disabled={disabled}
        >
          <Cross size="12" />
        </Button>
      )}
    </div>
  );
};

export const Chip = memo(ChipComponent);
